import * as React from "react"

type ShadcnInsetHeaderActionsContextValue = {
  actions: React.ReactNode | null
  setActions: (node: React.ReactNode | null) => void
  /** DOM mount for `createPortal` (keeps React context from the portaling page). */
  mountEl: HTMLDivElement | null
  setMountEl: (el: HTMLDivElement | null) => void
}

const ShadcnInsetHeaderActionsContext =
  React.createContext<ShadcnInsetHeaderActionsContextValue | null>(null)

export function ShadcnInsetHeaderActionsProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [actions, setActions] = React.useState<React.ReactNode | null>(null)
  const [mountEl, setMountEl] = React.useState<HTMLDivElement | null>(null)
  const value = React.useMemo(
    () => ({ actions, setActions, mountEl, setMountEl }),
    [actions, mountEl]
  )
  return (
    <ShadcnInsetHeaderActionsContext.Provider value={value}>
      {children}
    </ShadcnInsetHeaderActionsContext.Provider>
  )
}

export function useShadcnInsetHeaderActions() {
  const ctx = React.useContext(ShadcnInsetHeaderActionsContext)
  if (!ctx) {
    return {
      actions: null as React.ReactNode | null,
      setActions: (_node: React.ReactNode | null) => {},
      mountEl: null,
      setMountEl: (_el: HTMLDivElement | null) => {},
    }
  }
  return ctx
}
